import { useAuth } from '@/hooks/useAuth';
import ResellerLayout from '../components/ResellerLayout';

function Row({ label, value }: { label: string; value: string | number | null | undefined }) {
  return (
    <div className="flex items-center justify-between py-3 border-b border-[#E8E8E6] last:border-0">
      <span className="text-xs text-[#8A8A8A] uppercase tracking-wider">{label}</span>
      <span className="text-sm text-[#2A2A2A] font-medium">{value || '—'}</span>
    </div>
  );
}

export default function ResellerProfilePage() {
  const { resellerProfile } = useAuth();

  return (
    <ResellerLayout title="Profile">
      <div className="bg-white rounded-2xl border border-[#E8E8E6] p-6">
        <Row label="Business Name" value={resellerProfile?.name} />
        <Row label="Type" value={resellerProfile?.type} />
        <Row label="District" value={resellerProfile?.district} />
        <Row label="Contact" value={resellerProfile?.contact} />
        <Row label="Status" value={resellerProfile?.status} />
        <Row label="Wholesale Discount" value={resellerProfile?.wholesaleDiscountPct ? `${resellerProfile.wholesaleDiscountPct}%` : 'None'} />
      </div>
      <p className="text-xs text-[#8A8A8A] mt-4">
        To update your business details or documents, please contact us — profile changes are handled by our team.
      </p>
    </ResellerLayout>
  );
}
